export default __webpack_public_path__ + "static/media/admin-menu.77fb00a0.svg";